import { render, staticRenderFns } from "./PPCHeader.vue?vue&type=template&id=19711bc6&scoped=true&"
import script from "./PPCHeader.vue?vue&type=script&lang=js&"
export * from "./PPCHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19711bc6",
  null
  
)

export default component.exports